import { all } from 'redux-saga/effects';

import { watchStorageUpsellSagas } from './suggestions-sagas/storage-upsell-saga';

export function* watchSuggestionsSaga() {
  yield all([watchStorageUpsellSagas()]);
}
